export interface GMTool {
  title: string;
  desc: string;
  icon: string;
}

export const gmTools: ReadonlyArray<GMTool> = [
    {
    icon: '📖',
    title: 'Real Time Game Master Interface',
    desc: 'Start a home session and trigger encounters, monitor your players actions & status (HP & PP), and chat with them in real time.',
  },
  {
    icon: '🗺',
    title: 'Quest Builder',
    desc: 'Design Quests and campaigns with branching narratives, custom encounters, and location-based triggers — no coding required.',
  },
  {
    icon: '📖',
    title: 'Publish & Monetize Your Quests',
    desc: 'Publish Quests to the QuestXR marketplace. Set your own price and keep the majority of every sale.',
  },
  {
    icon: '✦',
    title: 'Build a Catalog',
    desc: ' Players discover and buy your adventures directly in the app so you can earn ongoing income from your creations.',
  },
  {
    icon: '📚',
    title: 'Asset Library',
    desc: "Create your own creatures, layouts, and encounters, or grab them from QuestXR's, or the Homebrew, library, optionally customize, and add them to your Quests.",
  },
  {
    icon: '🧙',
    title: 'NPC Scripting',
    desc: 'Give your characters personality, memory, and dialogue trees optionally powered by AI. Your NPCs remember the players.',
  },

];
